










import Vue from "vue";

export default Vue.extend({
    props: ['count', 'current'],
    mounted() {
        $('select').styler();
        $('select[name=count_on_page]').change(() => {
            let count = $('select[name=count_on_page]').val();
            this.select(count)
        });
    },
    methods: {
        select(count: number) {                
            this.$emit('updateCount', count)
        }
    }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/components/SelectOn.vue